<template>
    <div>
        <v-btn :style="{'right': (drawer)? width : '0px'}" color="primary" @click="drawer = !drawer" style="transition: all 200ms; z-index: 1000; border-top-right-radius: 0px; border-bottom-right-radius: 0px; top: 10vh" fixed top right fab><v-icon v-if="!drawer">mdi-account-badge-horizontal-outline</v-icon><v-icon v-if="drawer">mdi-close</v-icon></v-btn>
        <v-navigation-drawer
                v-model="drawer"
                :right="true"
                app
                :width="width"
        >
            <v-btn v-if="width == '100%'" @click="drawer = false" absolute right top color="primary" style="top: 1vh" fab small><v-icon>mdi-close</v-icon></v-btn>
            <v-list
                    v-if="contacts"
                    dense
                    nav
                    class="py-0"
            >
                <v-list-item two-line v-if="activeContact != null">
                    <v-list-item-avatar>
                        <img src="https://randomuser.me/api/portraits/men/81.jpg">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{activeContact.name}}</v-list-item-title>
                        <v-list-item-subtitle>
                            {{activeContact.city}} {{activeContact.postal}}
                            <br>
                            {{activeContact.street}}
                            <br>
                            <v-icon small class="mr-1">mdi-phone</v-icon>{{activeContact.phone}}
                            <span v-if="activeContact.email">
                                <br>
                                <v-icon small class="mr-1">mdi-email</v-icon>{{activeContact.email}}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="activeContact != null">
                    <v-list-item-content>
                        <v-btn @click="$store.commit('contacts/SET_ACTIVECONTACT', null)" depressed small>Wróć do listy</v-btn>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line v-if="activeContact == null">
                    <v-list-item-content>
                        <v-list-item-title>Lista twoich kontaktów</v-list-item-title>
                        <v-text-field clearable append-icon="mdi-magnify" outlined label="Szukaj" @click:clear="$store.dispatch('contacts/getContacts')" @click:append="search()" v-model="term" class="no-validation mt-2" dense></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="contacts == 'loading'">
                    <v-list-item-content>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="activeContact">
                    <v-list-item-content>

                        <v-select label="Język" :items="['PL', 'DE', 'EN', 'RU', 'IT']" v-model="edit.data['lang']"></v-select>
                        <v-textarea label="Opis" v-model="edit.data['comment']"></v-textarea>
                        <v-combobox
                                v-model="edit.data['tags']"
                                :items="tags"
                                label="Tagi użytkownika"
                                multiple
                        ></v-combobox>
                        <v-btn @click="updateUser()" color="primary">Zapisz</v-btn>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="contacts && contacts.data && contacts.data.length == 0">
                    <v-list-item-content>
                        <span>Brak kontaktów</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="activeContact == null" @click="$store.commit('contacts/SET_ACTIVECONTACT', contact)" v-for="contact in contacts.data" two-line>
                    <v-list-item-content>
                        <v-list-item-title>{{contact.name}}</v-list-item-title>
                        <v-list-item-subtitle>{{contact.city}} {{contact.postal}}
                            <br>
                            {{contact.street}}
                            <br>
                            <v-icon small class="mr-1">mdi-phone</v-icon>{{contact.phone}}
                            <span v-if="contact.email">
                                <br>
                                <v-icon small class="mr-1">mdi-email</v-icon>{{contact.email}}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="contacts && activeContact == null">
                    <v-pagination
                            @input="$store.dispatch('contacts/getContacts', {page: $event})"
                            :value="contacts.current_page"
                            :length="contacts.last_page"
                    ></v-pagination>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
    export default {
        data:() => {
            return {
                drawer: false,
                term: '',
                edit: null,
                tags:['VIP', 'Sprzedawca', 'Stały klient']
            }
        },
        watch:{
            activeContact: function(){
                if(this.activeContact){
                    this.edit = this.activeContact;
                }
            },
            drawer: function () {
                if(this.drawer && this.contacts == null){
                    this.$store.dispatch('contacts/getContacts');
                }
            }
        },
        computed:{
            contacts(){
              return this.$store.getters.contacts;
            },
            activeContact(){
              return this.$store.getters.activeContact
            },
            width(){
                if(this.$vuetify.breakpoint.smAndDown){
                    return '100%';
                }
                if(this.$vuetify.breakpoint.smAndUp && this.$vuetify.breakpoint.lgAndDown){
                    return '30vw'
                }
                return '20vw';
            }
        },
        methods:{
            updateUser(){
                this.$store.dispatch('contacts/updateActive', this.edit);
            },
            search(){
               this.$store.dispatch('contacts/getContacts', {term: this.term, page: 1});
            }
        }
    }
</script>
